import { useLocalStorage } from "@vueuse/core";
import { ELocalStorageKeys } from "~/features/store/ELocalStorageKeys";

const CACHE_SEARCH_CAPACITY = 4;

export class SearchHistoryStoreController {
  private _searchHistory = useLocalStorage<string[]>(ELocalStorageKeys.MM__SEARCH_HISTORY, [], {
    listenToStorageChanges: false,
    writeDefaults: false,
  });

  public get searchHistory(): string[] {
    return this._searchHistory.value;
  }

  public get lastSearchQuery(): string {
    return this._searchHistory.value[0] ?? '';
  }

  pushSearchHistoryValue(payload: string) {
    if (!this._searchHistory.value) return;
    if (!payload) return;
    
    const wordIndex = this._searchHistory.value.findIndex((word) => word === payload.toLowerCase());

    if (this._searchHistory.value.length && wordIndex > -1) {
      this._searchHistory.value.splice(wordIndex, 1);
    }

    if (payload) {
      this._searchHistory.value = [payload.toLowerCase(), ...this._searchHistory.value.slice(0, CACHE_SEARCH_CAPACITY - 1)];
    }
  }

  removeSearchHistoryValue(payload: string) {
    if (this._searchHistory.value.length) {
      this._searchHistory.value = this._searchHistory.value.filter((item) => item !== payload);
    }
  }

  clearSearchHistory() {
    this._searchHistory.value = [];
  }
}
